<template>
  <div>
    <b-modal
      footer="{null}"
      centered
      id="pin_code"
      title="Changer mon code de transfert"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
    >
      <div>
        <div v-if="is_ok == false">
          <div>
            <ValidationObserver v-slot="{ handleSubmit }">
              <b-form @submit.prevent="handleSubmit(sendRequest)">
                <b-form-group
                  id="input-group-1"
                  label="Nouveau code"
                  label-for="input-1"
                  description="Numéro à 4 chiffres"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|digits:4"
                    vid="form.code"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="form.code"
                      type="password"
                      placeholder="Entrer le nouveau code"
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  id="input-group-1"
                  label="Confirmer le code"
                  label-for="input-1"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required|digits:4|confirmed:form.code"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="form.confirm_code"
                      type="password"
                      placeholder="Confirmer le nouveau code"
                    ></b-form-input>
                    <VFieldErrors :errors="errors" class="w-100" />
                  </validation-provider>
                </b-form-group>
                <div class="mt-3 mb-3 text-right">
                  <button type="submit" class="btn btn-primary">
                    <b-spinner
                      small
                      v-if="is_loading"
                      label="Loading..."
                    ></b-spinner>
                    <span v-if="!is_loading">Valider</span>
                  </button>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
        <div
          v-if="is_ok == true"
          class="text-center modal-success-error-message"
        >
          <i class="mdi mdi-check"></i>
          <p class="text-muted">
            <b>Changement éffectué.</b> <br />
            Votre code de transfert a été changé avec succès.
          </p>
        </div>
      </div>
      <div></div>
    </b-modal>
  </div>
</template>
<script>
import VFieldErrors from "@/components/utils/VFieldsErrors";
import { subscriber } from "@/services/";
import { required, length, digits, confirmed } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
extend("required", {
  ...required,
  message: "Champ obligatoire",
});
extend("digits", {
  ...digits,
  message: "Vous devez entrer un code à 4 chiffres",
});
extend("confirmed", {
  ...confirmed,
  message: "Les deux codes ne correspondent pas.",
});
export default {
  name: "SimCodeMe2U",
  components: {
    VFieldErrors,
  },
  data: () => {
    return {
      is_ok: false,
      is_loading: false,
      current_step: 1,
      form: {
        code: "",
        confirm_code: "",
      },
    };
  },
  mounted() {},
  methods: {
    async sendRequest() {
      this.is_loading = true;
      var response = await subscriber.globalServiceRequest(
        "nikki",
        { code: this.form.code },
        "me2u_reset_pin"
      );
      if (!_.isUndefined(response.success)) {
        if (response.success == true) {
          this.is_ok = true;
        } else {
          this.is_ok = false;
        }
      }
      this.is_loading = false;
      setTimeout(() => {
        this.is_ok = false;
        this.form.code = "";
        this.form.confirm_code = "";
      }, 10000);
    },
  },
};
</script>
<style scoped lang="css">
#puk_details {
  font-weight: bold;
  font-size: 22px;
  letter-spacing: 2px;
}
::v-deep .modal-body {
  overflow-y: auto !important;
}
::v-deep label {
  font-size: 12px !important;
  margin-bottom: 3px !important;
  font-weight: 400 !important;
  font-weight: 700 !important;
}
::v-deep .form-text {
  font-size: 10px !important;
  color: #6c757d !important;
  font-weight: 400 !important;
}
::v-deep ::placeholder {
  color: #6c757d !important;
}
::v-deep .alert-warning {
  font-size: 12px !important;
  font-weight: 400 !important;
}
::v-deep select:focus,
input:focus {
  border: 1px solid #ced4da !important;
}
/* Chrome, Safari, Edge, Opera */
::v-deep input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0 !important;
}

/* Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}
</style>